//
// Based on https://reactrouterdotcom.fly.dev/docs/en/v6/examples/auth
//
import PropTypes from 'prop-types';
import {
  Navigate,
} from 'react-router-dom';

import { useAuth } from '../../stores';

function RequireAuth({
  children = null,
  redirectTo,
}) {
  const { auth } = useAuth();
  const { authStatus } = auth;

  // When auth is still initializing, return children.
  // LoadingGate (placed below this component) will block rendering
  // until all loaders (including auth) are complete.
  if (authStatus === 'init') {
    return children;
  }

  // User is logged in - render children
  if (authStatus === 'loggedIn') {
    return children;
  }

  // User is logged out - redirect to login page
  return <Navigate to={redirectTo} />;
}

RequireAuth.propTypes = {
  children: PropTypes.node,
  redirectTo: PropTypes.string.isRequired,
};

export default RequireAuth;
